// VOY-485 (rebuild) — Travel documents (Settings tab).
//
// Passport / known traveler / seat-map defaults — all rendered as
// placeholder cards. Passport entry flow is not yet built; this section
// surfaces the design's chrome with disabled CTAs so the row stays
// visible.
//
// SENSITIVE DATA RULES (hard requirement):
//   - Passport + known-traveler displayed MASKED-only. The mask is a
//     STATIC string — even when the user has a value on file (forthcoming),
//     the real value never enters this DOM.
//   - Never log full passport / known-traveler values anywhere.
//
// TODO: wire to passport storage when the secure entry form ships.
// TODO: wire to known-traveler storage.
// TODO: wire to seat_map_defaults preference.

export interface TravelDocumentsSectionProps {
  /** When true, render the static mask. Today: always false (no entry flow). */
  hasPassport?: boolean
}

export function TravelDocumentsSection({ hasPassport = false }: TravelDocumentsSectionProps) {
  return (
    <section className="card" aria-labelledby="docs-h">
      <div className="card-h">
        <h3 id="docs-h">Travel documents</h3>
        <span className="meta">FAST CHECKOUT</span>
      </div>
      <div className="grid-3" style={{ gap: 14 }}>
        <div className="card sm" style={{ background: 'var(--v6-surface-well)' }}>
          <div className="row between" style={{ marginBottom: 8 }}>
            <span className="lbl">PASSPORT</span>
            {hasPassport ? <span className="pill mint">● Verified</span> : <span className="pill">Not added</span>}
          </div>
          <div className="doc-card-value">{hasPassport ? 'PAA 123 ••••••' : '—'}</div>
          <div className="doc-card-sub">
            {hasPassport ? 'On file — masked for safety' : 'Speed up checkout by adding your passport.'}
          </div>
          <button type="button" className="btn-ghost" style={{ marginTop: 10, padding: '5px 11px', fontSize: 11 }} disabled title="Passport entry flow coming soon">
            {hasPassport ? 'Replace' : 'Add passport'}
          </button>
        </div>
        <div className="card sm" style={{ background: 'var(--v6-surface-well)' }}>
          <div className="row between" style={{ marginBottom: 8 }}>
            <span className="lbl">KNOWN TRAVELER</span>
            <span className="pill">Optional</span>
          </div>
          <div className="doc-card-value">—</div>
          <div className="doc-card-sub">For TSA PreCheck / Global Entry.</div>
          <button type="button" className="btn-ghost" style={{ marginTop: 10, padding: '5px 11px', fontSize: 11 }} disabled title="Known-traveler entry coming soon">
            Add number
          </button>
        </div>
        <div className="card sm" style={{ background: 'var(--v6-surface-well)' }}>
          <div className="row between" style={{ marginBottom: 8 }}>
            <span className="lbl">SEAT MAP DEFAULTS</span>
          </div>
          <div className="doc-card-value">Window · Front of cabin</div>
          <div className="doc-card-sub">Applied to every new flight search.</div>
          <button type="button" className="btn-ghost" style={{ marginTop: 10, padding: '5px 11px', fontSize: 11 }} disabled title="Seat preference editor coming soon">
            Edit
          </button>
        </div>
      </div>
    </section>
  )
}
